// Meta Pixel client-side helpers.
// The Pixel base code + init + auto PageView are installed in /public/index.html
// (site-wide). This module only exposes helpers to fire custom events
// (like Lead) with a shared event_id for CAPI deduplication, and to read
// fbp/fbc cookies for the server-side call.

/** Fire a Pixel event with a shared event_id for CAPI deduplication. */
export function pixelTrack(eventName, params = {}, eventId) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  try {
    window.fbq('track', eventName, params, { eventID: eventId });
  } catch (_) {
    // Nunca romper la UX por un evento de tracking.
  }
}

/** Read a cookie value (or null). */
export function getCookie(name) {
  if (typeof document === 'undefined') return null;
  const prefix = `${name}=`;
  const row = document.cookie.split('; ').find((c) => c.startsWith(prefix));
  return row ? decodeURIComponent(row.slice(prefix.length)) : null;
}

/** If the URL has ?fbclid=..., persist a proper _fbc cookie
 *  (format: fb.1.{createdMs}.{fbclid}). Returns the current _fbc value. */
export function ensureFbcFromFbclid() {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const fbclid = params.get('fbclid');
  if (!fbclid) return getCookie('_fbc');

  const existing = getCookie('_fbc');
  const existingClick = existing ? existing.split('.').slice(3).join('.') : null;
  if (existing && existingClick === fbclid) return existing;

  const fbc = `fb.1.${Date.now()}.${fbclid}`;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `_fbc=${encodeURIComponent(fbc)}; Max-Age=7776000; Path=/; SameSite=Lax${secure}`;
  return fbc;
}

/** Generate a namespaced UUID (prefix helps debugging in Events Manager). */
export function newEventId(prefix = 'evt') {
  const uuid =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `${prefix}_${uuid}`;
}
